import { takeLatest } from 'redux-saga/effects';
import { clearToken } from '../../utilities/tokenStorage';
import { LOGOUT } from '../reducer';
import { clearLiveChat } from '../../utilities/liveChat';

export function* logoutSaga() {
  yield takeLatest(LOGOUT, clearToken);
  yield takeLatest(LOGOUT, clearLiveChat);
}
